/* eslint-disable lingui/text-restrictions */

import { t } from "@lingui/macro";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
// import { openai } from "./client";

type PromptResponse = {
  message?: string | number;
};

const PROMPT = `You are an AI writing assistant specialized in writing copy for resumes.
Do not return anything else except the text you improved. It should not begin with a newline. It should not have any prefix or suffix text.
Improve the writing of the following text and return it in the language of the input.
If the input is already structured like resume bullets or a list, preserve that structure and return one bullet per line instead of a paragraph.

Text: """{input}"""

Revised Text: """`;

export const requestPrompt = async (data: string) => {
  const response = await axios.post<PromptResponse, AxiosResponse<PromptResponse>>(
    "/auth/requestPrompt",
    { prompt: data },
  );

  return response.data;
};

export const improveWriting = async (text: string) => {
  const prompt = PROMPT.replace("{input}", text);
  const result = await requestPrompt(prompt);
  // const result = await openai().chat.completions.create({
  //   messages: [{ role: "user", content: prompt }],
  //   model: "gpt-3.5-turbo",
  //   max_tokens: 1024,
  //   temperature: 0,
  //   stop: ['"""'],
  //   n: 1,
  // });

  if (result.message === 0) {
    throw new Error(t`OpenAI did not return any choices for your text.`);
  }

  return typeof result.message === "string" ? result.message : text;
};
